import React from 'react';
import PropTypes from 'prop-types';
import Translation from '../../../translation/translation';

function MissingLoadIndex(props) {
    return (
        <span className="statusbar__missing-status">
            <Translation translationKey="catalog-missing-status-speed-index-hint" />
            {' '}
            <Translation
                translationKey="catalog-missing-status-missing-load-index"
                className="statusbar__add-information"
                onClick={props.onClick}
            />
        </span>
    );
}

MissingLoadIndex.propTypes = {
    onClick: PropTypes.func.isRequired
};

export default MissingLoadIndex;
